<template>
  <div class="container">
    <div class="upload">
      <div class="card" :class="{ shakeX : uploadFailed }">
        <div class="card-body">
          <h1 class="card-title">J’importe mon fichier Epanet *</h1>
          <p class="card-text">Veuillez utiliser un fichier INP normalisé et fonctionnel provenant d'un export EPANET</p>
          <div v-if="form.files.length === 0">
            <div class="drop-container">
              <div class="instructions">
                <img src="../assets/logo_INP.svg" alt="format inp">
                <p>Cliquez sur “ajouter un fichier” ou déposez vos fichier ici</p>
              </div>
            </div>
            <small>* Par mesure de sécurité, vos fichiers seront supprimés après la simulation;Naega DI permet, pour chaque nœud du réseau, un calcul automatisé de la pression au débit que vous souhaitez à 20h, pour un fichier Epanet démarrant à 0h. A chaque nœud, la demande incendie modélisée s'ajoute à la demande existante du modèle.</small>
            <form id="fileForm">
              <label for="fileInput" role="button">
                <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Information:"><path d="M15 0a15 15 0 100 30 15 15 0 000-30zm0 28a13 13 0 110-26 13 13 0 010 26z" fill="#3DA7DD"/><path d="M21.93 14H16V8.07a1 1 0 10-2 0V14H8.07a1 1 0 000 2H14v5.93a1 1 0 002 0V16h5.93a1 1 0 100-2z" fill="#3DA7DD"/></svg>
                Ajouter un fichier</label>
              <input id="fileInput" type="file" accept=".inp" @change="dialogAddFiles" multiple class="visually-hidden">
            </form>
          </div>
          <div v-else>
            <div v-if="!uploadFailed" class="alert alert-info" role="alert">
              <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13" cy="13" r="12" stroke="currentColor" stroke-width="2"/><path d="M11.568 8.148a.568.568 0 01-.409-.152.59.59 0 01-.159-.413V5.564c0-.159.053-.289.16-.39A.578.578 0 0111.567 5h2.841a.53.53 0 01.41.174.486.486 0 01.181.39v2.02a.568.568 0 01-.59.564h-2.842zm0 12.852a.621.621 0 01-.409-.152.564.564 0 01-.159-.39V10.253c0-.16.053-.29.16-.391a.621.621 0 01.408-.152h2.841c.167 0 .303.05.41.152a.486.486 0 01.181.39v10.204c0 .16-.06.29-.182.391a.568.568 0 01-.409.152h-2.84z" fill="currentColor"/></svg>
              Pour démarrer le calcul de vos données, choisissez un débit et veuillez cliquer sur le bouton 'envoyer'.
            </div>
            <div v-if="uploadFailed" class="alert alert-danger" role="alert">
              <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13" cy="13" r="12" stroke="currentColor" stroke-width="2"/><path d="M11.568 8.148a.568.568 0 01-.409-.152.59.59 0 01-.159-.413V5.564c0-.159.053-.289.16-.39A.578.578 0 0111.567 5h2.841a.53.53 0 01.41.174.486.486 0 01.181.39v2.02a.568.568 0 01-.59.564h-2.842zm0 12.852a.621.621 0 01-.409-.152.564.564 0 01-.159-.39V10.253c0-.16.053-.29.16-.391a.621.621 0 01.408-.152h2.841c.167 0 .303.05.41.152a.486.486 0 01.181.39v10.204c0 .16-.06.29-.182.391a.568.568 0 01-.409.152h-2.84z" fill="currentColor"/></svg>
              {{ errorMessage }}
            </div>
            <div class="file-infos">
              <span class="file-name"> {{ form.files[0].name }} </span>
              <span class="file-size"> {{ toKb(form.files[0].size) }} ko</span>
              <button class="btn" @click="removeFiles" title="supprimer">
                <svg width="11" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.044 0C3.364 0 2.8.563 2.8 1.244v.312H1.711c-.94 0-1.711.77-1.711 1.71V4.2c0 .244.222.467.467.467h.155V12.6c0 .768.633 1.4 1.4 1.4H8.867c.767 0 1.4-.633 1.4-1.4V4.667h.155a.485.485 0 00.467-.467v-.933c0-.94-.771-1.711-1.711-1.711h-1.09v-.312C8.089.564 7.527 0 6.845 0h-2.8zm0 .933h2.8a.3.3 0 01.312.311v.312H3.734v-.312a.3.3 0 01.31-.31zM1.711 2.49H9.178c.439 0 .778.339.778.778v.466H.934v-.466c0-.44.338-.778.777-.778zm-.155 2.178H9.334V12.6c0 .267-.2.467-.467.467H2.022a.456.456 0 01-.466-.467V4.667zm1.71.933a.466.466 0 00-.466.467v5.6a.466.466 0 10.933 0v-5.6a.466.466 0 00-.466-.467zm2.178 0a.466.466 0 00-.466.467v5.6a.466.466 0 10.933 0v-5.6a.466.466 0 00-.467-.467zm2.178 0a.466.466 0 00-.466.467v5.6a.466.466 0 10.933 0v-5.6a.466.466 0 00-.467-.467z" fill="#000"/></svg>
              </button>
            </div>
            <form id="sendForm" @submit.prevent="submitForm">
              <label for="inputDebit">Débit en m&sup3;/h</label>
              <div class="input-group has-validation" :class="{ filled : form.debit > 0}">
                <input class="form-control" :class="{ 'is-invalid' : formValidation && !debitIsValid }" type="text" placeholder="0" aria-label="Modéliser" id="inputDebit" v-model.number="form.debit">
                <button class="btn btn-primary" :disabled="!formIsValid">Modéliser</button>
              </div>
              <div class="invalid-feedback" v-if="formValidation && !debitIsValid">Doit être un nombre > 0</div>
              <small v-if="!formValidation" class="input-info">Veuillez choisir un débit</small>
            </form>
          </div>
        </div>
      </div>
      <a class="btn btn-outline-secondary mt-4" href="../">Annuler</a>
    </div>
  </div>
  <teleport to="body">
    <div id="dropZone" tabindex="0" @dragover.prevent @drop.stop.prevent="addFiles">
      <div class="dash">
        <h2>Déposez votre fichier dans cette fenêtre</h2>
      </div>
    </div>
  </teleport>
</template>

<script>

export default {
  name: 'Upload',
  props: {
    formProp: Object,
    uploadFailed: Boolean,
    errorMessage: String
  },
  emits: ['upload-file'],
  components: {},
  data () {
    return {
      form: this.formProp,
      formValidation: false
    }
  },
  computed: {
    debitIsValid () {
      return typeof this.form.debit === 'number' && this.form.debit > 0
    },
    formIsValid () {
      return this.debitIsValid
    }
  },
  watch: {
    'form.debit': function (val) {
      if (typeof val !== 'undefined' && val !== '') {
        this.formValidation = true
      } else {
        this.formValidation = false
      }
    }
  },
  methods: {
    addFiles (e) {
      e.dataTransfer.files.forEach((file) => {
        const fileExt = file.name.split('.').pop()

        if (fileExt === 'inp') {
          this.form.files.push(file)
        } else {
          document.querySelector('.upload .card').classList.add('shakeX')
        }
      })
    },
    dialogAddFiles (e) {
      e.target.files.forEach((file) => {
        const fileExt = file.name.split('.').pop()

        if (fileExt === 'inp') {
          this.form.files.push(file)
        } else {
          document.querySelector('.upload .card').classList.add('shakeX')
        }
      })
    },
    removeFiles () {
      this.form.files = []
    },
    removeFile (file) {
      this.form.files = this.form.files.filter(f => {
        return f !== file
      })
    },
    toKb (val) {
      return Math.ceil(val / 1024)
    },
    submitForm () {
      if (this.formIsValid) {
        this.$emit('upload-file', this.form)
      }
    }
  }
}
</script>

<style scoped>
  .drop-container {
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='5' ry='5' stroke='%233DA7DDFF' stroke-width='1' stroke-dasharray='5%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: .3125rem;
    height: 16.875rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .instructions {
    text-align: center;
    margin: 0 5rem;
  }

  .instructions img {
    margin: 0 auto 1.25rem;
  }

  .drop-container + small {
    display: block;
    font-size: .75rem;
    color: var(--naega-red);
    margin-top: 1rem;
  }

  .upload {
    padding: 4rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background-image: url(../assets/blob.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .upload .card {
    width: 32rem;
    padding: 3.125rem 2.375rem;
  }

  .upload .card h1 {
    font-size: 1.5rem;
    font-weight: 700;
  }

  .upload .card-body {
    padding: 0;
  }

  .upload .alert {
    font-size: .875rem;
    color: var(--text-black);
    display: flex;
    align-items: center;
    border-radius: .3125rem;
    padding: 3.125rem 1.25rem 2.5rem;
    margin-bottom: .5rem;
  }

  .upload .alert svg {
    flex-shrink: 0;
    margin-right: 1.25rem;
  }

  .upload .alert-info {
    background-color: var(--primary-light);
  }

  .upload .alert-danger svg {
    transform: rotate(180deg);
  }

  #fileForm {
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
  }

  #fileForm label {
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--text-black);
    display: flex;
    align-items: center;
  }

  #fileForm label:hover {
    cursor: pointer;
  }

  #fileForm label svg {
    margin-right: 1.25rem;
  }

  #fileForm label:hover path {
    fill: var(--primary-dark);
  }

  .file-infos {
    display: flex;
    font-size: .75rem;
    align-items: center;
    justify-content: space-between;
  }

  .file-infos .btn {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  #sendForm {
    display: flex;
    flex-wrap: wrap;
    margin: 5rem 0 4.5rem;
  }

  #sendForm label {
    font-size: .875rem;
    width: 100%;
  }

  #sendForm .input-group {
    border: 1px solid var(--input-border-default);
    border-radius: .375rem;
    padding: 3px;
  }

  #sendForm input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: var(--input-placeholder);
    opacity: 1; /* Firefox */
  }

  #sendForm .input-group:hover {
    border-color: var(--input-border-hover);
  }

  #sendForm .input-group:hover input::placeholder {
    color: var(--input-placeholder-hover);
  }

  #sendForm .input-group.filled {
    border-color: var(--input-border-filled);
  }

  #sendForm .input-group .btn {
    border-top-left-radius: .25rem !important;
    border-bottom-left-radius: .25rem !important;
  }

  #sendForm input {
    border: 0;
  }

  .input-info {
    font-size: .875rem;
    display: block;
    margin-top: .25rem;
    color: var(--input-info);
  }

  .invalid-feedback {
    display: block;
    color: var(--naega-red);
  }
</style>
